var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(" Stripe email verification ")]),_c('ul',[_c('li',[_vm._v("christine.chalvardjian@trans-plus.com")]),_c('li',[_vm._v("arpayment@trans-plus.com")])])])
}]

export { render, staticRenderFns }